module.exports = __webpack_public_path__ + "static/media/icon-menu.b7ecefff.svg";